import { render, staticRenderFns } from "./Dropzone.vue?vue&type=template&id=3f27a452"
import script from "./Dropzone.vue?vue&type=script&lang=js"
export * from "./Dropzone.vue?vue&type=script&lang=js"
import style0 from "./Dropzone.vue?vue&type=style&index=0&id=3f27a452&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports